module.exports = __webpack_public_path__ + "media/images/ecute/ecuteueno_zh-hant_PC-972236300d3e2d9e325737eb1b080e26.jpg";